export const SANDO_WHATSAPP_NUMBER = "573332391400";

export const SANDO_WHATSAPP_DISPLAY = "333 239 1400";

export const SANDO_INSTAGRAM_URL = "https://instagram.com/sandobyceron";

export const SANDO_INSTAGRAM_HANDLE = "@sandobyceron";

export const SANDO_ADDRESS = "Cl 19A Norte #15 Norte - 55, Armenia, Quindío";

export const SANDO_HOURS: { days: string; hours: string }[] = [
  { days: "Lunes a jueves", hours: "12:00 p.m. – 4:00 p.m. y 5:45 p.m. – 9:00 p.m." },
  { days: "Viernes", hours: "12:00 p.m. – 4:00 p.m. y 5:45 p.m. – 10:00 p.m." },
  { days: "Sábado", hours: "12:00 p.m. – 10:00 p.m." },
  { days: "Domingo", hours: "1:00 p.m. – 5:00 p.m." },
];

export const SANDO_LOGO =
  "https://public.readdy.ai/ai/img_res/c0c4eab5-54fe-48c9-9183-0c6ea71f1186.png";

export const SANDO_MAP_EMBED =
  "https://www.google.com/maps?q=Cl%2019A%20Norte%20%2315%20Norte%20-%2055%2C%20Armenia%2C%20Quind%C3%ADo&output=embed";

export const SANDO_MAP_LINK =
  "https://www.google.com/maps/search/?api=1&query=Cl+19A+Norte+%2315+Norte+-+55%2C+Armenia%2C+Quind%C3%ADo";

/* Variable única para reemplazar el video del hero por el archivo oficial.
   Déjala vacía para mostrar solo la imagen de respaldo. */
export const SANDO_HERO_VIDEO = "";

/* Variable única para el video de la sección "Por qué Sando".
   Acepta un enlace de YouTube (youtu.be o youtube.com) o la URL directa de un
   archivo de video. Déjala vacía para mostrar el espacio con la imagen de respaldo. */
export const SANDO_CRAFT_VIDEO = "https://youtu.be/4RwqDmuUZM8";

export const SANDO_NAV_LINKS = [
  { id: "carta", label: "Carta", href: "#carta" },
  { id: "combos", label: "Combos", href: "#combos" },
  { id: "como-pedir", label: "Cómo pedir", href: "#como-pedir" },
  { id: "como-llegar", label: "Cómo llegar", href: "#como-llegar" },
];

export const SANDO_FOOTER_LINKS = [
  { id: "inicio", label: "Inicio", href: "#inicio" },
  { id: "carta", label: "Carta", href: "#carta" },
  { id: "combos", label: "Combos", href: "#combos" },
  { id: "por-que", label: "Por qué Sando", href: "#por-que" },
  { id: "como-pedir", label: "Cómo pedir", href: "#como-pedir" },
  { id: "como-llegar", label: "Cómo llegar", href: "#como-llegar" },
];

export const WA_MESSAGES = {
  general: "Hola Sando 👋 quiero hacer un pedido.",
  combos: "Hola Sando 👋 ¿qué combos tienen hoy?",
  delivery: "Hola Sando 👋 ¿hacen domicilio a mi zona?",
  dishPrefix: "Hola Sando 👋 quiero pedir el ",
};